export default __webpack_public_path__ + "static/14-0769add5475dafdb76bc9fe7dfb791e7.jpg";